import React from "react";
import { Bot, Plus, Search } from "lucide-react";

export default function AIAssistantSection() {
  return (
    <section className="py-12 md:py-16 bg-[#f4f2fb]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden bg-[#090214] border border-purple-900/30  min-h-[300px] flex items-center">
          
          {/* Background Orbit Circles & Purple Stars - Matched to Image */}
          <div className="absolute -left-1/4 top-1/2 -translate-y-1/2 w-[150%] h-[150%] aspect-square rounded-full border border-purple-500/10 pointer-events-none" />
          <div className="absolute -left-1/3 top-1/2 -translate-y-1/2 w-[170%] h-[170%] aspect-square rounded-full border border-purple-500/5 pointer-events-none" />

          {/* Floating Purple Stars from Reference */}
          <Plus className="absolute left-[10%] top-[25%] w-5 h-5 text-purple-600/60" strokeWidth={1.5} />
          <Plus className="absolute left-[5%] bottom-[15%] w-6 h-6 text-purple-600/70" strokeWidth={1} />
          <Plus className="absolute left-[25%] top-[10%] w-4 h-4 text-purple-600/50" strokeWidth={2} />
          <Plus className="absolute left-[35%] bottom-[30%] w-4 h-4 text-purple-600/50" strokeWidth={2} />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center  w-full p-8 md:p-12 lg:p-16 relative z-10">
            
            {/* LEFT SIDE: Matching Phone Mockup */}
            <div className="lg:col-span-6 relative flex items-center justify-center lg:justify-center">
              
              {/* Phone Frame - Narrower and matches reference proportions */}
              <div className="relative w-64 sm:w-72 h-[260px] md:h-[280px] bg-slate-950 rounded-[36px] border-[6px] border-slate-800 shadow-2xl p-2.5 overflow-hidden flex flex-col">
                {/* Phone Notch */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-4.5 bg-slate-900 rounded-b-xl z-30 flex items-center justify-center">
                  <div className="w-10 h-1.5 bg-slate-700 rounded-full" />
                </div>
                
                {/* Phone Screen Display */}
                <div className="w-full h-full bg-[#110424] rounded-[26px] p-3 flex flex-col relative overflow-visible pt-10">
                  
                  {/* Phone Screen Header - Matched to image */}
                  <div className="flex items-center justify-between mb-4 px-1">
                    <Search className="w-4 h-4 text-purple-300/70" />
                    <span className="text-[10px] text-white/90 font-medium">AI Trip Assistant</span>
                    <div className="w-4 h-4" /> {/* Spacer */}
                  </div>

                  {/* Top Chat Bubble (Inside Phone - User Query) - Blueish as in Image */}
                  <div className="self-end bg-gradient-to-r from-[#4A3AFF] to-[#7D70FF] text-white text-[10px] md:text-xs font-normal px-4 py-2.5 rounded-[20px] rounded-br-none shadow-lg max-w-[80%] leading-snug mb-3">
                    Where should I go for a 5 day trip in Thailand?
                  </div>

                  {/* Bottom Chat Bubble (Inside Phone - AI Response) - Purple and longer text */}
                  <div className="relative self-start bg-[#7A1FD6] text-white text-[9px] md:text-[10.5px] font-normal px-4 py-3 rounded-[20px] rounded-bl-none shadow-lg max-w-[85%] leading-relaxed">
                    Based on your interests, I recommend Phuket, Krabi and Phi Phi Islands. Perfect beaches, fun activities and great food!

                    {/* Robot Badge - Precisely positioned based on image */}
                    <div className="absolute -right-12 bottom-1 w-11 h-11 rounded-full bg-[#7A1FD6] border-4 border-[#3D0A75] text-white flex items-center justify-center shadow-lg shadow-black/20 z-40 p-1.5">
                       <Bot className="w-full h-full" strokeWidth={1} />
                    </div>
                  </div>

                </div>
              </div>

            </div>

            {/* RIGHT SIDE: Content & Action Buttons - Matched to Image */}
            <div className="lg:col-span-6 text-white space-y-4">
              <span className="text-[10px] font-extrabold text-purple-400 uppercase tracking-widest block opacity-70">
                AI TRIP ASSISTANT
              </span>

              <h2 className="text-3xl md:text-4xl lg:text-[40px] font-extrabold leading-tight tracking-tight">
                Plan Every Journey <br />
                Smarter with <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-white">AI</span>
              </h2>

              <p className="text-sm md:text-base text-purple-100/70 max-w-lg leading-relaxed pt-1">
                Get personalized recommendations, smart itineraries <br/> and travel tips powered by AI.
              </p>

      
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}